import { LightningElement, track, api  } from 'lwc';

/* Usage Examples
    Defaults:
        size: none (native)
        color: none (native)
        btnPosition: 'center'
        okLabel: 'OK'
        cancelLabel: 'Cancel'
        isSlot: false

    Example 1 (all public properties):
        // A dark medium-sized footer with buttoms to left and custom Button labels
        <slds-footer
            size="medium"
            color="dark"
            btn-position="left"
            ok-label="Save"
            cancel-label="Delete"
            oncancel={myCancelHandler}
            onokay={myOkayHandler}
        ></slds-footer>

    Example 2 (Minimal Setup):
        // Uses the defaults for <size>, <btnPosition>, <okLabel>, <cancelLabel>, <btnPosition>
        <x-slds-footer
            oncancel={myCancelHandler}
            onokay={myOkayHandler}
        ></x-slds-footer>

    Example 3 (Common Setup):
        // Footer with buttons centered and medium padding
        <x-slds-footer
            size="medium"
            oncancel={myCancelHandler}
            onokay={myOkayHandler}
        ></x-slds-footer>

    Example 4 (Slot Setup):
        // **Must add is-slot="true"** Only the <size> and <color> can be  specified
        
        <x-slds-footer 
        size="medium"
        color="dark"
        > 
            <div class="slds-grid">
                <template for:each={pills} for:item="pill">
                    <span class="slds-pill slds-pill_link">
                        <a href="javascript:void(0);" class="slds-pill__action" title={pill.label}><span class="slds-pill__label">{pill.label}</span></a>
                        <button class="slds-button slds-button_icon slds-button_icon slds-pill__remove" title="Remove">
                            <svg class="slds-button__icon" aria-hidden="true"><use xlink:href="static/assets/icons/utility-sprite/svg/symbols.svg#close"></use></svg>
                            <span class="slds-assistive-text">Remove</span>
                        </button>
                    </span>
                </template>
            </div>
        </x-slds-footer>

*/

const SIZES = ['small', 'medium', 'large'];         // padding options
const COLORS = ['light', 'normal', 'dark'];        // background options
const POSITIONS = ['left', 'center', 'right']     // Button position options

export default class sldsFooter extends LightningElement {
    static renderMode = 'light';
    
    @api size;                                // Padding size of footer (small/medium/large)
    @api color;                              // background color of footer (light/medium/dark)
    @api okLabel = 'OK';                    // Confirm button label
    @api cancelLabel = 'Cancel';           // Cancel button label
    @api btnPosition = 'center';          // Button position (left/center/right)


    @api // All public properties ignored except <size> & <color>
    set isSlot(val) {
        this._isSlot = val && (val === "true" || val === true);
    }   
    get isSlot() {
        return this._isSlot;
    }  

    // Add Background color and padding amount if specified
    get footerClass() {
        // Base
        let footerClass = 'slds-popover__footer';

        // Add padding if size specified
        if (this.size && SIZES.some(s => s === this.size)) {
            footerClass = `${footerClass} slds-p-around_${this.size}`;
        }

        // Add background-color if size specified
        if (this.color && COLORS.some(c => c === this.color)) {
            footerClass = `${footerClass} footer-${this.color}`;
        }
        return footerClass;
    }

    // Position OK/Cancel buttons (left/center/right)
    get btnPositionClass() {
        return this.btnPosition === 'left'
            ? 'slds-grid slds-grid_align-start slds-gutters_xx-small'
                : this.btnPosition === 'right'
            ? 'slds-grid slds-grid_align-end slds-gutters_xx-small'
            : 'slds-grid slds-grid_align-center slds-gutters_xx-small'; // center = default 
    }

    // Send cancel event to parent
    handleCancel() {
        this.dispatchEvent(new CustomEvent('cancel', { detail: '' } ));
    }
    
    // Send Okay event to parent
    handleOkay() {
        this.dispatchEvent(new CustomEvent('okay', { detail: '' } ));
    }
}